import {
  ChevronLeftIcon,
  ChevronRightIcon,
  DoubleArrowLeftIcon,
  DoubleArrowRightIcon,
} from '@radix-ui/react-icons';
import { Box, Flex } from '@radix-ui/themes';
import { TableContext } from 'components/common/table/context';
import { CommonTablePaginationButton } from 'components/common/table/pagination-button';
import { CheckedContext } from 'contexts/layout/checked.context';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext } from 'react';

export const PaginationSelector = (props: {
  pageSize: number;
  total: number;
}) => {
  const { maxPage, pageData, selectedCoord, setSelectedCoord } =
    useContext(TableContext);

  const checkedCx = useContext(CheckedContext);

  const isFirst = selectedCoord.page === 0;
  const isLast = selectedCoord.page === maxPage;

  const startIndex = (selectedCoord.page ?? 0) * props.pageSize + 1;
  const endIndex = startIndex + Math.min(props.pageSize, pageData.length) - 1;

  const summary =
    pageData.length === 0
      ? t('common.no-data')
      : t('common.table-rows-summary', {
          first: startIndex,
          last: endIndex,
          total: props.total,
        });

  const resetLastCheckedIndex = () => {
    if (checkedCx) {
      checkedCx.setLastCheckedIndex(null);
    }
  };

  return (
    <Flex gap={RADIX.FLEX.GAP.MD}>
      <Flex gap={RADIX.FLEX.GAP.SM}>
        <CommonTablePaginationButton
          disabled={isFirst}
          tooltip={t('common.first-page').toString()}
          onClick={() => {
            setSelectedCoord({
              page: 0,
              index: -1,
              _id: null,
              callbackKey: null,
            });
            resetLastCheckedIndex();
          }}
          icon={<DoubleArrowLeftIcon />}
        />

        <CommonTablePaginationButton
          disabled={isFirst}
          tooltip={t('common.previous-page').toString()}
          onClick={() => {
            setSelectedCoord({
              page: selectedCoord.page - 1,
              index: -1,
              _id: null,
              callbackKey: null,
            });
            resetLastCheckedIndex();
          }}
          icon={<ChevronLeftIcon />}
        />
      </Flex>

      <Box className="valign-center">{summary}</Box>

      <Flex gap={RADIX.FLEX.GAP.XS}>
        <CommonTablePaginationButton
          disabled={isLast}
          tooltip={t('common.next-page').toString()}
          onClick={() => {
            setSelectedCoord({
              page: selectedCoord.page + 1,
              index: -1,
              _id: null,
              callbackKey: null,
            });
            resetLastCheckedIndex();
          }}
          icon={<ChevronRightIcon />}
        />

        <CommonTablePaginationButton
          disabled={isLast}
          tooltip={t('common.last-page').toString()}
          onClick={() => {
            setSelectedCoord({
              page: maxPage,
              index: -1,
              _id: null,
              callbackKey: null,
            });
            resetLastCheckedIndex();
          }}
          icon={<DoubleArrowRightIcon />}
        />
      </Flex>
    </Flex>
  );
};
